// @flow

const integrationsContentStyles = {
  integrationsContent: (theme) => ({
    flexGrow: 1,
    marginTop: theme.layout.customProps.header.height, // Position below single-row header
    padding: theme.spacing(3),
    width: '100%',
    minWidth: 'auto', // Remove fixed width constraint to prevent overflow
    overflow: 'hidden', // Contain content within viewport
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),  // 12px padding on mobile
      minWidth: 0
    }
  }),
  contentCtr: (theme) => ({
    '& p': {
      fontSize: '0.9rem'
    }
  }),
  ctaBtnAnchor: (theme) => ({
    marginBottom: theme.spacing(2),
    textDecoration: 'none'
  }),
  ctaBtn: (theme) => ({
    marginTop: theme.spacing(2),
    '& span': {
      textDecoration: 'none'
    }
  }),
  paragraph: (theme) => ({
    display: 'block',
    marginTop: theme.spacing(2)
  })
};

export default integrationsContentStyles;
